export function getBrowserType() {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  
  const test = regexp => regexp.test(userAgent);
  
  if (test(/opr\//i) || !!window.opr) {
    return 'Opera';
  } else if (test(/edg/i)) {
    return 'Microsoft Edge';
  } else if (test(/chrome|chromium|crios/i)) {
    return 'Google Chrome';
  } else if (test(/firefox|fxios/i)) {
    return 'Mozilla Firefox';
  } else if (test(/safari/i) && !test(/chrome|chromium|crios/i)) {
    // Deteksi Safari (Desktop vs Mobile)
    if (/iphone|ipad|ipod/.test(userAgent) || (platform === 'macintel' && 'ontouchend' in document)) {
      return 'Apple Safari (iOS)'; // Safari di iOS (iPhone/iPad)
    } else {
      return 'Apple Safari (Desktop)'; // Safari di Desktop (macOS)
    }
  } else if (test(/trident/i)) {
    return 'Microsoft Internet Explorer';
  } else if (test(/ucbrowser/i)) {
    return 'UC Browser';
  } else if (test(/samsungbrowser/i)) {
    return 'Samsung Browser';
  } else {
    return 'Unknown browser';
  }
}

export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=" + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ";";
}

export function updateCookie(cname, cvalue) {
  var ed = getCookie('created_at');
  if(ed) {
    var d = new Date(ed);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=" + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ";";
  }  
}

export function text_truncate(str, length = 100, ending = '...') {
  return str.length > length ? str.substring(0, length - ending.length) + ending : str;
}